import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CloseIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M6.7 5.3a1 1 0 0 0-1.4 1.4l5.29 5.3-5.3 5.3a1 1 0 1 0 1.42 1.4L12 13.42l5.3 5.3a1 1 0 0 0 1.4-1.42L13.42 12l5.3-5.3a1 1 0 0 0-1.42-1.4L12 10.58l-5.3-5.3Z" />
  </Icon>
));
export default CloseIcon;
